import React from 'react';
import PropTypes from 'prop-types';


import * as phoneConstants from '../phoneConstants';
import * as phoneFormConstants from './phoneFormConstants';

import FormElement from '../../../../global/Form/FormElement';
import FormFieldError from '../../../../global/Form/FormFieldError';
import TextInput from '../../../../global/Form/Input';
import ValidatingForm from '../../../../global/Form/ValidatingForm';
import {CountryFlag, CountrySelect, useCountries} from '../../../Geo';
import {inputConstants} from '../../../../global/Form/Input';

import styles from './PhoneForm.scss';


function PhoneForm(props) {

    const countries = useCountries();
    if (countries.length === 0) {

        return null;
    }

    const getCountryByAlpha2 = countryAlpha2 => countries.find(country => country.alpha2 === countryAlpha2);

    const {phone} = props;

    return (
        <ValidatingForm
            data={phone}
            id={'phone.form'}
            onIsInvalid={data => props.onData(data, false)}
            onIsValid={data => props.onData(data, true)}
            validationSchema={phoneFormConstants.SCHEMA_PHONE_FORM}
        >
            {({form}) => (

                <FormElement
                    {...props}
                    labelI18n={props.labelI18n || 'phone.form.field.phone.label'}
                    labelClass={styles.formElementPhone}
                >

                    <div className={'row'}>

                        <CountrySelect
                            id={`${props.id}Country`}
                            name={`${props.name}Country`}
                            onChange={countryAlpha2 => {

                                if (!countryAlpha2) {
                                    form.setData({
                                        callingCode: undefined,
                                        countryAlpha2: undefined
                                    });

                                    return;
                                }

                                const selectedCountry = getCountryByAlpha2(countryAlpha2);
                                form.setData({
                                    callingCode: selectedCountry.callingCode,
                                    countryAlpha2
                                });
                            }}
                            placeholderI18n={'phone.form.field.countryAlpha2.placeholder'}
                            renderContent={({callingCode, name, nativeName}) => (
                                <>
                                    {name} ({nativeName}) <span>+{callingCode}</span>
                                </>
                            )}
                            renderSelectedContent={({alpha2, callingCode}) => (
                                <div className={styles.phoneCountryOption}>
                                    <CountryFlag countryAlpha2={alpha2}/>
                                    +{callingCode} (0)
                                </div>
                            )}
                            value={form.getData('countryAlpha2')}
                        />

                        <TextInput
                            autocomplete={inputConstants.AUTOCOMPLETE_TEL_LOCAL}
                            id={`${props.id}Number`}
                            isDisabled={props.isDisabled}
                            maxLength={phoneFormConstants.PHONE_NUMBER_MAX}
                            name={`${props.name}Number`}
                            onChange={number => {

                                // setting countryAlpha2 to trigger validation
                                form.setData({
                                    countryAlpha2: form.getData('countryAlpha2'),
                                    number
                                });
                            }}
                            onChangeFilter={number => {
                                if (number) {

                                    return number.replace(/\D+/g, '');
                                }

                                return number;
                            }}
                            placeholderI18n={'phone.form.field.number.placeholder'}
                            type={inputConstants.TYPE_PHONE}
                            value={form.getData('number')}
                        />

                    </div>

                    <div className={'row'}>
                        <div className={'col-12'}>
                            <FormFieldError error={form.getCurrentError('countryAlpha2')}/>
                        </div>
                        <div className={'col-12'}>

                            <FormFieldError error={form.getCurrentError('number')}/>

                            {!form.hasError('countryAlpha2') && !form.hasError('number') && form.hasError('phone') && (
                                <FormFieldError error={form.getError('phone')}/>
                            )}

                        </div>
                    </div>

                </FormElement>
            )}
        </ValidatingForm>
    );
}


PhoneForm.propTypes = {
    ...FormElement.propTypes,
    onData: PropTypes.func.isRequired,
    phone: phoneConstants.SHAPE_PHONE
};

PhoneForm.defaultProps = {
    ...FormElement.defaultProps,
    id: 'phone',
    name: 'phone',
    phone: {
        callingCode: undefined,
        countryAlpha2: undefined,
        number: undefined
    }
};


export default PhoneForm;
